// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2025 (original work) Open Assessment Technologies SA ;
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.gradingProjects.edit],
        controller: () => import('./controllers/gradingProject.controller.js'),
        guard: getPermissionsGuard([{ resource: 'portal.grading-project', scopes: ['edit'] }])
    },
    {
        path: [config.routes.gradingProjects.create],
        controller: () => import('./controllers/gradingProject.controller.js'),
        guard: getPermissionsGuard([{ resource: 'portal.grading-project', scopes: ['create'] }])
    },
    {
        path: [config.routes.gradingProjects.answers],
        controller: () => import('./controllers/gradingProjectAnswers.controller.js'),
        guard: getPermissionsGuard([{ resource: 'portal.grading-project', scopes: ['view'] }])
    },
    {
        path: [config.routes.gradingProjects.items],
        controller: () => import('./controllers/gradingProjectItems.controller.js'),
        guard: getPermissionsGuard([{ resource: 'portal.grading-project', scopes: ['view'] }])
    },
    {
        path: [config.routes.gradingProjects.list],
        controller: () => import('./controllers/gradingProjectsList.controller.js'),
        guard: getPermissionsGuard([{ resource: 'portal.grading-project', scopes: ['view'] }])
    }
];
